import React from 'react'
import { startCase } from 'lodash'

import { ICON_PATHS } from '../../../common/constants'
import * as IconComponents from '../../icons'

export type IconName =
  | 'actions'
  | 'archive'
  | 'calendar'
  | 'care-plans'
  | 'checkbox-off'
  | 'checkbox-on'
  | 'clock'
  | 'document'
  | 'flag'
  | 'family-update'
  | 'health-visit'
  | 'incident'
  | 'info'
  | 'grid'
  | 'medication'
  | 'overdue'
  | 'pdf'
  | 'pencil'
  | 'print'
  | 'profile'
  | 'radio-off'
  | 'radio-on'
  | 'skip'
  | 'social'
  | 'three-bars'
  | 'three-dots'
  | 'tick-in-circle'
  | 'play'

interface IconProps {
  fill?: string
  url?: string
  name?: IconName
  viewBox?: string
  style?: React.CSSProperties
  size?: number
}

const Icon: React.FC<IconProps> = ({
  fill = 'white',
  name,
  size = 24,
  style = {},
  url,
  viewBox = '0 0 24 24',
}) => {
  const componentName = startCase(name).replace(/\s/g, '')
  // @ts-ignore
  const IconComponent = IconComponents[componentName]
  if (IconComponent) {
    return (
      <IconComponent fill={fill} size={size} style={style} viewBox={viewBox} />
    )
  }
  if (url) {
    return (
      <div style={{ height: size, width: size }}>
        <img alt="" src={url} style={style} />
      </div>
    )
  }

  return (
    <svg
      height={size}
      width={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* @ts-ignore */}
      <path fill={fill} d={ICON_PATHS[name]} />
    </svg>
  )
}

export default Icon
